class INTENT.widgets.EmailEventSubscriptions

  @ATTR_NAME: "data-widget-email-event-subscriptions"

  constructor: (@el) ->
    el = @el
    @el.on 'switchChange.bootstrapSwitch', (e, s) ->
      if s
        action = 'renewUserSubscription'
      else
        action = 'unsubscribeUser'
      loaderContainer = $(e.target).parent().find('.bootstrap-switch-handle-' + (if s then 'off' else 'on'))
      $.ajax {
          url: '/ajax/event_subscription'
          method: 'post'
          data: {
            event: el.data 'eventId'
            action: action
          }
          beforeSend: ->
            $(e.target).prop 'disabled', on
            loaderContainer.showLoader()
      }
      .done (r) ->
        $(e.target).prop 'disabled', no
        loaderContainer.hideLoader()
        if r.status and 'renewUserSubscription' == action
          $(e.target).bootstrapSwitch 'state', on
          INTENT.utils.Notify.success __("email_subscription.state.active")
        if r.status and 'unsubscribeUser' == action
          $(e.target).bootstrapSwitch 'state', no
          INTENT.utils.Notify.success __("email_subscription.state.disabled")
        if not r.status
          $(e.target).bootstrapSwitch 'state', (if s then no else on), on
          INTENT.utils.Notify.error __("campaigns.internal-server-error")





